import React from "react";

function Error() {
  return <div>404</div>;
}

export default Error;
